import {
  createContext,
  Dispatch,
  ReactElement,
  SetStateAction,
  useMemo,
  useState,
} from 'react'

import { type FiatTokenInfo } from '@/hooks/use-tokens'
import PaymentInfoProvider from '@/providers/payment-info'

export type SellContextType = {
  fiatToken: FiatTokenInfo | undefined,
  setFiatToken: (fiatToken: FiatTokenInfo) => void,
  isOpenRenecInsufficientWarning: boolean,
  setIsOpenRenecInsufficientWarning: Dispatch<SetStateAction<boolean>>,
}

const initContextState: SellContextType = {
  fiatToken: undefined,
  setFiatToken: () => null,
  isOpenRenecInsufficientWarning: false,
  setIsOpenRenecInsufficientWarning: () => false,
}

const SellContext = createContext<SellContextType>(initContextState)

export const SellProvider = ({ children }: HocProps): ReactElement => {
  const [fiatToken, setFiatToken] = useState<FiatTokenInfo>()
  const [isOpenRenecInsufficientWarning, setIsOpenRenecInsufficientWarning] = useState(false)

  const contextValue = useMemo(() => {
    return {
      fiatToken,
      setFiatToken,
      isOpenRenecInsufficientWarning,
      setIsOpenRenecInsufficientWarning,
    }
  }, [
    fiatToken,
    setFiatToken,
    isOpenRenecInsufficientWarning,
    setIsOpenRenecInsufficientWarning,
  ])

  return (
    <SellContext.Provider value={contextValue}>
      <PaymentInfoProvider fixedFiatToken={fiatToken}>
        {children}
      </PaymentInfoProvider>
    </SellContext.Provider>
  )
}

SellContext.displayName = 'SellContext'
export default SellContext
